export enum MODULE_NAME {
    dostavkee = 'dostavkee',
    corpdrivee = 'corpdrivee',
}
